export default __webpack_public_path__ + "static/media/34.4e73547e.png";